import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=fa6b157c&scoped=true"
import script from "./nav.vue?vue&type=script&lang=js"
export * from "./nav.vue?vue&type=script&lang=js"
import style0 from "./nav.vue?vue&type=style&index=0&id=fa6b157c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"
import style1 from "./nav.vue?vue&type=style&index=1&id=fa6b157c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b157c",
  null
  
)

export default component.exports